import axios from 'axios'
import { STOCKS_ENDPOINT } from '../../endpoints'

export async function uploadCargaMasiva(file){
    const formData = new FormData();
    formData.append('file',file)
    const response = await axios.post(`${STOCKS_ENDPOINT}/uploadStockFile`,formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout: 300000 // 5 minutos
      })
    return response
}